import { BaseTexture } from "../resource/BaseTexture";
import { ILaya } from "../../ILaya";
import { TextureDimension } from "../RenderEngine/RenderEnum/TextureDimension";
import { TextureFormat } from "../RenderEngine/RenderEnum/TextureFormat";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { FilterMode } from "../RenderEngine/RenderEnum/FilterMode";
import { WrapMode } from "../RenderEngine/RenderEnum/WrapMode";
import { Texture2D } from "../resource/Texture2D";
import { LayaGL } from "../layagl/LayaGL";
import { Event } from "../events/Event";
import { PAL } from "../platform/PlatformAdapters";
import { LayaEnv } from "../../LayaEnv";
import { AssetDb } from "../resource/AssetDb";
export class VideoTexture extends BaseTexture {
    static createInstance() {
        return PAL.media.createVideoTexture();
    }
    constructor() {
        super(1, 1, RenderTargetFormat.R8G8B8);
        this.allowBackground = false;
        this._playing = false;
        this._loaded = false;
        this._frameRender = true;
        this._interval = 0;
        this._lastTimer = 0;
        this._frameRate = 0;
        this._useMediaFrameRate = true;
        this._loop = false;
        this._autoResume = false;
        this._dimension = TextureDimension.Tex2D;
    }
    get frameRate() {
        return this._frameRate;
    }
    set frameRate(value) {
        if (value < 0.001)
            this._interval = 0;
        else
            this._interval = 1000 / value;
        this._frameRate = value;
    }
    get useMediaFrameRate() {
        return this._useMediaFrameRate;
    }
    set useMediaFrameRate(value) {
        this._useMediaFrameRate = value;
    }
    get frameRender() {
        return this._frameRender;
    }
    set frameRender(value) {
        if (this._loaded) {
            if (this._frameRender && !value)
                ILaya.timer.clear(this, this.render);
            if (!this._frameRender && value && this._playing)
                ILaya.timer.frameLoop(1, this, this.render);
        }
        this._frameRender = value;
    }
    get source() {
        return this._source;
    }
    set source(url) {
        this.load(url);
    }
    get currentTime() {
        return 0;
    }
    set currentTime(value) {
    }
    get volume() {
        return 0;
    }
    set volume(value) {
    }
    get muted() {
        return false;
    }
    set muted(value) {
    }
    get readyState() {
        return 0;
    }
    get videoWidth() {
        return this._width;
    }
    get videoHeight() {
        return this._height;
    }
    get duration() {
        return 0;
    }
    get ended() {
        return false;
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        this._loop = value;
    }
    get playbackRate() {
        return 1;
    }
    set playbackRate(value) {
    }
    get paused() {
        return false;
    }
    canPlayType(type) {
        return PAL.media.canPlayType(type);
    }
    setLoaded(width, height, rgba) {
        this._width = width;
        this._height = height;
        this._loaded = true;
        this._texture = LayaGL.textureContext.createTextureInternal(this._dimension, width, height, rgba ? TextureFormat.R8G8B8A8 : TextureFormat.R8G8B8, false, false, false);
        this.wrapModeU = WrapMode.Clamp;
        this.wrapModeV = WrapMode.Clamp;
        this.filterMode = FilterMode.Bilinear;
        LayaGL.textureContext.initVideoTextureData(this._texture);
        this._texture.gammaCorrection = 2.2;
        if (this._frameRender && this._playing)
            ILaya.timer.frameLoop(1, this, this.render);
        if (this._playing)
            this.onPlay();
        this.event(Event.READY, this);
    }
    render(force) {
        if (!this._loaded)
            return;
        if (!this._useMediaFrameRate && !force) {
            let now = performance.now();
            if (now - this._lastTimer < this._interval)
                return;
            this._lastTimer = now;
        }
        if (this.onRender())
            this.event("videoUpdate");
    }
    load(url) {
        this._source = url;
        if (url) {
            if (this._texture) {
                this._texture.dispose();
                this._texture = null;
            }
            AssetDb.inst.resolveURL(url, url2 => {
                if (this._source === url)
                    this.onLoad(url2);
            });
        }
        else
            this.pause();
    }
    play() {
        if (this._playing || !LayaEnv.isPlaying)
            return;
        this._playing = true;
        ILaya.stage.on(Event.BLUR, this, this.onBlur);
        if (this._loaded) {
            if (this._frameRender)
                ILaya.timer.frameLoop(1, this, this.render);
            this.onPlay();
        }
    }
    pause() {
        this._autoResume = false;
        if (!this._playing)
            return;
        this._playing = false;
        ILaya.stage.off(Event.BLUR, this, this.onBlur);
        ILaya.timer.clear(this, this.render);
        if (this._loaded)
            this.onPause();
    }
    resume() {
        this.play();
    }
    get gammaCorrection() {
        return 2.2;
    }
    _getSource() {
        return this._texture ? this._texture.resource : Texture2D.blackTexture._getSource();
    }
    get defaultTexture() {
        return Texture2D.blackTexture;
    }
    destroy() {
        this._playing = false;
        ILaya.timer.clear(this, this.render);
        ILaya.stage.off(Event.BLUR, this, this.onBlur);
        this.onDestroy();
        super.destroy();
    }
    onBlur() {
        if (!this.allowBackground)
            PAL.media.resumeUntilGotFocus(this);
    }
    onLoad(url) {
    }
    onRender() {
        return false;
    }
    onPlay() {
    }
    onPause() {
    }
    onDestroy() {
    }
    get currentSrc() {
        return this._source;
    }
    get updateFrame() {
        return this.frameRate;
    }
    set updateFrame(value) {
        this.frameRate = value;
    }
    get useFrame() {
        return this.useMediaFrameRate;
    }
    set useFrame(value) {
        this.useMediaFrameRate = value;
    }
}
